import { Inbox, type LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  body?: string;
  cta?: ReactNode;
}

/** Универсальный пустой экран (dashed border, иконка, заголовок, опц. CTA). */
export function EmptyState({ icon: Icon = Inbox, title, body, cta }: EmptyStateProps) {
  return (
    <div
      className="rounded-card text-center flex flex-col items-center"
      style={{ background: '#F3F4F6', border: '1px dashed #E5E7EB', padding: '48px 32px' }}
    >
      <Icon size={48} stroke="#6B7280" />
      <h4
        className="font-heading text-ink mt-4"
        style={{ fontSize: 18, fontWeight: 600, letterSpacing: '-0.01em' }}
      >{title}</h4>
      {body && <p className="text-muted mt-2" style={{ fontSize: 14, maxWidth: 480, lineHeight: 1.55 }}>{body}</p>}
      {cta && <div className="mt-5">{cta}</div>}
    </div>
  );
}
